import React from "react";
import { FiTarget } from "react-icons/fi";
import MiniGamePage from "./MiniGamePage";
import { tapGameApi } from "../../utils/miniGameApi";

const TapGame = () => (
  <MiniGamePage
    title="Tap Game"
    selfLabel="Tap Game"
    description="Manage Tap Game settings and view user play history."
    icon={FiTarget}
    api={tapGameApi}
    scoreLabel="Taps"
    switchTo={[
      { to: "/boom-cards-game", label: "Boom Cards" },
      { to: "/game-2048", label: "2048" },
    ]}
  />
);

export default TapGame;
